// extracted by mini-css-extract-plugin
module.exports = {"body":"forminput_body__3YkcU","input":"forminput_input__p3mUI","input_error":"forminput_input_error__G33OO","error":"forminput_error__1u-07"};